import { createFileRoute } from "@tanstack/react-router";

import { AdminCostsScreen } from "@/features/admin/screens/AdminCosts";

export const Route = createFileRoute("/_authenticated/(admin)/admin/costs")({
  component: AdminCostsScreen,
});
